import {Component, OnDestroy, OnInit} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import { Subscription } from 'rxjs';
import { Message } from 'primeng/message';
import { GlobalMessageModel } from '../../core/models/global-message.model';

@Component({
  selector: 'app-global-notifications',
  template: `
    @for (message of staticMessages; track message.key) {
      <p-message [styleClass]="'global-message'" [severity]="message.severity" [icon]="getIcon(message)" [closable]="false">
        <b>{{ message.summary }}</b> {{ message.detail }}
      </p-message>
    }
    @for (message of closableMessages; track message.key) {
      <p-message [styleClass]="'global-message'" [severity]="message.severity" [icon]="getIcon(message)" [closable]="true" (onClose)="onClosableMessagesChange(message, $event)">
        <b>{{ message.summary }}</b> {{ message.detail }}
      </p-message>
    }
  `,
  imports: [Message],
  standalone: true,
})
export class GlobalNotificationsComponent implements OnInit, OnDestroy {
  staticMessages: Array<GlobalMessageModel> = [];
  closableMessages: Array<GlobalMessageModel> = [];

  staticMessagesSubscription: Subscription;
  closableMessagesSubscription: Subscription;

  constructor(public headerService: HeaderService) {}

  ngOnInit() {
    this.staticMessages = this.headerService.staticMessages;

    this.staticMessagesSubscription = this.headerService.staticMessagesSubject.subscribe(list => {
      console.log('staticMessages', list);
      this.staticMessages = [];
      if (list && list.length > 0) {
        this.staticMessages = list;
      }
    });

    this.closableMessages = this.headerService.closableMessages;

    this.closableMessagesSubscription = this.headerService.closableMessagesSubject.subscribe(list => {
      console.log('closableMessages', list);
      this.closableMessages = [];
      if (list && list.length > 0) {
        this.closableMessages = list;
      }
    });
  }

  ngOnDestroy(): void {
    this.staticMessagesSubscription?.unsubscribe();
    this.closableMessagesSubscription?.unsubscribe();
  }

  onClosableMessagesChange(message: GlobalMessageModel, $event: any) {
    this.closableMessages = this.closableMessages.filter((msg) => msg.key !== message.key);
    this.headerService.closableMessagesSubject.next(this.closableMessages);
  }

  getIcon(message: GlobalMessageModel)
  {
    switch (message.severity) {
      case 'info':
        return 'pi pi-info-circle';
      case 'warn':
        return 'pi pi-exclamation-triangle';
      case 'error':
        return 'pi pi-times-circle';
      case 'success':
        return 'pi pi-check-circle';
      default:
        return '';
    }
  }
}
